import type { UserExaminationStatistics } from 'src/types/examination';

import useSWR from 'swr';

import { fetcher, endpoints } from 'src/lib/axios';

import { UserExaminationStatisticsSchema } from 'src/types/examination';

export function useExaminationUserStatistics(lessonId?: number, todoId?: number) {
  const { data, error, isLoading, mutate } = useSWR<UserExaminationStatistics>(
    lessonId && todoId ? ['userStatistics', lessonId, todoId] : null,
    async () => {
      const rawData = await fetcher(
        endpoints.examination.userStatisticsByLessonAndTodo(lessonId!, todoId!)
      );
      return UserExaminationStatisticsSchema.parse(rawData);
    }
  );

  if (!lessonId) {
    throw new Error('no lesson id provided');
  }

  if (!todoId) {
    throw new Error('no todo id provided');
  }

  return {
    userStatistics: data,
    isLoading,
    error,
    refetch: mutate,
  };
}
